import useReadMoreHook from '@/components/tv/hooks/useReadMoreHook'
import { Button, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'

interface ReadMoreProps {
    text: string
    maxTextLength?: number
}

const ReadMore = ({ text, maxTextLength = 100 }: ReadMoreProps) => {
    const { isFolded, setIsFolded } = useReadMoreHook()
    const toggleReadMore = (event: React.MouseEvent) => {
        event.preventDefault()
        event.stopPropagation()
        setIsFolded(!isFolded)
    }

    const { ref: readMoreButtonRef, focused: isFocusedReadMore } = useFocusable(
        {
            focusable: true,
            forceFocus: true,
            focusKey: 'readMoreButton',
            onEnterPress: toggleReadMore,
        }
    )

    const buttonStyle = {
        lineHeight: '14px',
        color: 'white',
        padding: '8px 0',
        textAlign: 'left',
        minWidth: 'unset',
        textDecoration: 'underline',
        border: isFocusedReadMore ? '5px solid red' : 'none',
    }

    return (
        <Typography
            display="flex"
            flexDirection="column"
            alignItems="start"
            component="p"
            variant="subtitle2"
            mt="25px">
            <Typography minHeight="35px" component="span">
                {text.length > maxTextLength && isFolded
                    ? text
                    : `${text.slice(0, maxTextLength)} ${
                          text.length > maxTextLength ? '...' : ''
                      }`}
            </Typography>
            {text.length > maxTextLength && (
                <Button
                    onClick={toggleReadMore}
                    sx={buttonStyle}
                    ref={readMoreButtonRef}>
                    {isFolded ? t('readLess') : t('readMore')}
                </Button>
            )}
        </Typography>
    )
}

export default ReadMore
